const AnalysisIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.78 4H22.02V8.24" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
            <path
                d="M22.0201 4L12.6801 13.27L10.6801 11.27L2.62012 19.34"
                stroke="white"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M2.54004 2.01001V18.01C2.54004 19.67 3.88004 21.01 5.54004 21.01H21.54"
                stroke="white"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    )
}

AnalysisIcon.displayName = 'AnalysisIcon'

export default AnalysisIcon
